var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAddCircle48Filled = function SvgIconAddCircle48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.784 12.18a16.69 16.69 0 1 0 0 23.62 16.72 16.72 0 0 0 0-23.62Zm-2.81 13.51h-7.3v7.3h-3.35v-7.3h-7.3v-3.4h7.3v-7.3h3.4v7.3h7.3l-.05 3.4Z",
    fill: "current"
  })));
};
export default SvgIconAddCircle48Filled;